class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('summary');
    this.main_element = this.summary.nextElementSibling;
    this.summary.setAttribute('role', 'button');
    this.summary.setAttribute('aria-expanded', this.details.hasAttribute('open'));
    this.close_button = this.querySelectorAll('[details-close]');
    this.type = this.details.getAttribute('action').toLowerCase();
    this.hasAnimation = this.details.getAttribute('has_animation') == "true";

    this.summary.addEventListener('click', this.onToggle.bind(this));
    this.details.addEventListener('keyup', this.onKeyUpEscape.bind(this));
    if (this.main_element.getAttribute('id') != undefined) {
      this.summary.setAttribute('aria-controls', this.main_element.id);
    }
    if (this.summary.getAttribute('outsideclick_close') == "true") {
      this.details.addEventListener('focusout', this.onFocusOut.bind(this));
    }
    if (this.close_button != undefined) {
      this.close_button.forEach((button) => {
        button.addEventListener('click', this.close.bind(this));
      })
    }
  }
 

  onFocusOut(event) {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle(event) {   
    event.preventDefault();
    this.animation();
    // toggle state
    if (this.hasAnimation) {
      if (this.details.hasAttribute('open')) {
        this.summary.setAttribute('aria-expanded', false);
        setTimeout(()=> {
          this.details.toggleAttribute('open');
        }, 100);
      } else {
        this.details.toggleAttribute('open');
        setTimeout(()=> {
        this.summary.setAttribute('aria-expanded', true);
        }, 10)
      }
    } else {
      this.details.toggleAttribute('open');
      this.summary.setAttribute('aria-expanded', this.details.hasAttribute('open'))
    }
  }

  animation() {
    if (this.type == "drawer") {
      if (this.details.hasAttribute('open')) {
        this.summary.classList.remove('show-drawer');
        document.querySelector('body').classList.remove('js-drawer--open');
      } else {
        setTimeout(()=> {
          this.summary.classList.add('show-drawer');
          document.querySelector('body').classList.add('js-drawer--open');
        },10)
      }
    } else {
      if (this.details.hasAttribute('open')) {
        this.setHeight(0);
      } else {
        let counter = 0;
        let check_height = setInterval(() => {
          console.log(this.main_element.querySelector('.details__content-inner').offsetHeight)
          counter = counter + 1;
          this.setHeight(this.main_element.querySelector('.details__content-inner').offsetHeight);
          if (this.main_element.querySelector('.details__content-inner').offsetHeight != 0 || counter == 200) {
            clearInterval(check_height);
          }
        }, 10);
        
        
      }
    }
  }

  setHeight(height) {
    setTimeout(() => {
      this.main_element.style.height = height + "px";
    }, 10)
  }
  close() {
    if (this.hasAnimation || this.type == "drawer") {
      this.summary.classList.remove('show-drawer');
      this.details.querySelector('summary').setAttribute('aria-expanded', false);
      setTimeout(()=> {
        this.details.removeAttribute('open');
      }, 300);
    } else {
      this.details.removeAttribute('open');
      this.details.querySelector('summary').setAttribute('aria-expanded', false);
    }
    document.querySelector('body').classList.remove('js-drawer--open');
  }
  onKeyUpEscape(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      const openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;
      const summaryElement = openDetailsElement.querySelector('summary');
      openDetailsElement.removeAttribute('open');
      summaryElement.setAttribute('aria-expanded', false);
      summaryElement.focus();
  }
}

customElements.define('details-disclosure', DetailsDisclosure);